import { useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useIsTablet } from "../../../../hooks/useWidth";
import { Submenu } from "../Submenu";

interface NavItemProps {
  item: {
    label: string;
    url: string;
    children?: {
      label: string;
      url: string;
    }[];
  },
  subMenuClick?(e: any): void
}

export function NavItem({ item, subMenuClick }: NavItemProps) {
  const navigate = useNavigate();
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const handleClickOnLink = (e: any) => {
    e.stopPropagation();
    const to = e.currentTarget.getAttribute('data-to');
    if (to) navigate(to);
  };
  
  const isTablet = useIsTablet();
  
  return (
    <Content
      data-to={`/${item.url}`}
      onClick={e => (isTablet && item.children) ? setIsSubmenuOpen(!isSubmenuOpen) : handleClickOnLink(e)}
    >
      {
        <LinkUI
          data-to={`/${item.url}`}
          onClick={e => (isTablet && item.children) ? setIsSubmenuOpen(!isSubmenuOpen) : handleClickOnLink(e)}
        >
          { item.label }
        </LinkUI>
      }
      {item.children && (
        <>
          <ChevronRightUI size={20} />
          <ChevronDownUI size={12} />
        </>
      )}
      {item.children && <Submenu items={item.children} isSubmenuOpen={isSubmenuOpen} onClick={subMenuClick} /> }
    </Content>
  );
}

const Content = styled.li`
  display: flex;
  align-items: center;
  color: #fff;
  text-transform: uppercase;
  padding: 26px 20px 20px;
  cursor: pointer;
  position: relative;
  font-size: 20px;

  > a {
    color: #fff;
    text-decoration: none;
  }

  &:hover, &:active {
    color: ${({ theme }: any) => theme.colors.pink.light};

    > a {
      color: ${({ theme }: any) => theme.colors.pink.light};
    }

    > ul {
      opacity: 1;
      visibility: visible;
      top: 70px;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 26px;
    padding: 8px 32px 8px 0;
    border-bottom: 2px solid #fff;
    flex-wrap: wrap;

    > a {
      display: block;
      width: 100%;
      flex: 1;
    }
  }
`;

const LinkUI = styled.a`
  color: #fff;

  &:hover, &:active {
    color: ${({ theme }: any) => theme.colors.pink.light};
  }
`;

const ChevronDownUI = styled(FaChevronDown)`
  margin-left: 4px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: none;
  }
`;

const ChevronRightUI = styled(FaChevronRight)`
  margin-left: 4px;
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: block;
  }
`;